var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogout(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    viewBox: "0 0 36 36",
    preserveAspectRatio: "xMidYMid meet",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.9001 2.70001H17.1001V13.5H18.9001V2.70001ZM3.6001 18.8993C3.6001 13.2871 6.81065 8.42479 11.4953 6.04878L12.8452 7.39866C8.45657 9.36878 5.4001 13.7771 5.4001 18.8993C5.4001 25.8581 11.0413 31.4993 18.0001 31.4993C24.9589 31.4993 30.6001 25.8581 30.6001 18.8993C30.6001 13.7531 27.5148 9.32738 23.0931 7.37105L24.4454 6.01876C29.1623 8.38367 32.4001 13.2634 32.4001 18.8993C32.4001 26.8522 25.953 33.2993 18.0001 33.2993C10.0472 33.2993 3.6001 26.8522 3.6001 18.8993Z",
    fill: "#5B47FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout);
export default __webpack_public_path__ + "static/media/logout.d902e514cd00a85a6324166bc7cce0ff.svg";
export { ForwardRef as ReactComponent };